import { createIcon } from '@chakra-ui/react/icon'

const CreditCardIcon = createIcon({
  displayName: 'CreditCardIcon',
  viewBox: '0 0 16 16',
  path: [
    <path
      fill="currentColor"
      d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z"
    />,
    <path fill="currentColor" d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z" />,
  ],
})

export default CreditCardIcon
